// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social__links[data-v-58058952]{display:inline-block;margin-right:16px}.social__links[data-v-58058952]:last-child{margin-right:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
